import { render, staticRenderFns } from "./LoVotesList.vue?vue&type=template&id=3f4686b9&scoped=true"
import script from "./LoVotesList.vue?vue&type=script&lang=js"
export * from "./LoVotesList.vue?vue&type=script&lang=js"
import style0 from "./LoVotesList.vue?vue&type=style&index=0&id=3f4686b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4686b9",
  null
  
)

export default component.exports